import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import Index from '@/components/Index'
import Company from '@/components/Company'
import User from '@/components/User'
import Logs from '@/components/Logs'
import Qutype from '@/components/Qutype'
import Agents from '@/components/Agents'
import Sign from '@/components/Sign'
import Query from '@/components/Query'
import ModiPwd from '@/components/ModiPwd'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      children: [
        {
          path: '/company',
          name: 'Company',
          component: Company,
          meta: {
            index: "1-1",
            label: "基础数据>公司信息"
          }
        }, {
          path: '/user',
          name: 'User',
          component: User,
          meta: {
            index: "1-2",
            label: "基础数据>操作人员"
          }
        }, {
          path: '/logs',
          name: 'Logs',
          component: Logs,
          meta: {
            index: "1-3",
            label: "基础数据>登录日志"
          }
        }, {
          path: '/qutype',
          name: 'Qutype',
          component: Qutype,
          meta: {
            index: "1-4",
            label: "基础数据>资质类型"
          }
        }, {
          path: '/cpwd',
          name: 'ModiPwd',
          component: ModiPwd,
          meta: {
            index: "1-5",
            label: "基础数据>密码修改"
          }
        }, {
          path: '/agents',
          name: 'Agents',
          component: Agents,
          meta: {
            index: "2-1",
            label: "签约管理>客户档案"
          }
        }, {
          path: '/sign',
          name: 'Sign',
          component: Sign,
          meta: {
            index: "2-2",
            label: "签约管理>签约登记"
          }
        }
      ]
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/query',
      name: 'Query',
      component: Query
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js